import React from "react";
import StatusBadge from "./StatusBadge";
import { formatNumber, formatPercent, formatSigned } from "../utils/formatters";

function MetricRow({ label, baseValue, targetValue, deltaValue, kind = "number" }) {
  const format = (value) => {
    if (kind === "percent") return formatPercent(value, 1);
    if (kind === "status") return <StatusBadge status={value} />;
    if (kind === "text") return value || "-";
    return formatNumber(value, 1);
  };

  return (
    <tr>
      <th>{label}</th>
      <td>{format(baseValue)}</td>
      <td>{format(targetValue)}</td>
      <td>{kind === "status" || kind === "text" ? "-" : formatSigned(deltaValue, 1)}</td>
    </tr>
  );
}

export default function ScenarioComparisonPanel({
  scenarioSummaries,
  activeScenarioId,
  compareScenarioId,
  onChangeCompareScenario,
  comparison,
}) {
  const base = comparison?.base;
  const target = comparison?.target;
  const delta = {
    plan: (target?.aggregate?.planTotal || 0) - (base?.aggregate?.planTotal || 0),
    simulated:
      (target?.aggregate?.simulatedTotal || 0) - (base?.aggregate?.simulatedTotal || 0),
    realized: (target?.aggregate?.realizedTotal || 0) - (base?.aggregate?.realizedTotal || 0),
    attendancePct:
      (target?.aggregate?.attendancePct || 0) - (base?.aggregate?.attendancePct || 0),
    gap: (target?.aggregate?.gap || 0) - (base?.aggregate?.gap || 0),
  };

  return (
    <section className="swb-panel">
      <div className="swb-panel__head">
        <h3>Comparação de cenários</h3>
        <label className="swb-inline-field">
          <span>Comparar com</span>
          <select value={compareScenarioId || ""} onChange={(e) => onChangeCompareScenario(e.target.value || null)}>
            <option value="">Selecione</option>
            {(scenarioSummaries || [])
              .filter((scenario) => scenario.id !== activeScenarioId)
              .map((scenario) => (
                <option key={scenario.id} value={scenario.id}>
                  {scenario.name}
                </option>
              ))}
          </select>
        </label>
      </div>

      <div className="swb-compare-head">
        <div>
          <strong>Base:</strong> {base?.name || "-"} <span className="swb-subtle">({base?.period || "-"})</span>
        </div>
        <div>
          <strong>Selecionado:</strong> {target?.name || "-"} <span className="swb-subtle">({target?.period || "-"})</span>
        </div>
      </div>

      <div className="swb-table-wrap">
        <table className="swb-table swb-table--compact">
          <thead>
            <tr>
              <th>Métrica</th>
              <th>Base</th>
              <th>Selecionado</th>
              <th>Delta</th>
            </tr>
          </thead>
          <tbody>
            <MetricRow
              label="Plano"
              baseValue={base?.aggregate?.planTotal}
              targetValue={target?.aggregate?.planTotal}
              deltaValue={delta.plan}
            />
            <MetricRow
              label="Simulado"
              baseValue={base?.aggregate?.simulatedTotal}
              targetValue={target?.aggregate?.simulatedTotal}
              deltaValue={delta.simulated}
            />
            <MetricRow
              label="Realizado (mock)"
              baseValue={base?.aggregate?.realizedTotal}
              targetValue={target?.aggregate?.realizedTotal}
              deltaValue={delta.realized}
            />
            <MetricRow
              label="% Atendimento"
              baseValue={base?.aggregate?.attendancePct}
              targetValue={target?.aggregate?.attendancePct}
              deltaValue={delta.attendancePct}
              kind="percent"
            />
            <MetricRow
              label="Gap/Folga"
              baseValue={base?.aggregate?.gap}
              targetValue={target?.aggregate?.gap}
              deltaValue={delta.gap}
            />
            <MetricRow
              label="Status"
              baseValue={base?.aggregate?.status}
              targetValue={target?.aggregate?.status}
              kind="status"
            />
            <MetricRow
              label="Gargalo"
              baseValue={base?.aggregate?.mainBottleneck}
              targetValue={target?.aggregate?.mainBottleneck}
              kind="text"
            />
          </tbody>
        </table>
      </div>
    </section>
  );
}
